import React, { Component } from 'react';
import cn from 'classnames';
import styles from './Menu.scss';

const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

class Menu extends Component {

  preventDefault = (e) => {
    /* e = e || window.event;
    const scrollTop = this.scrollContainer.scrollTop;
    if (
      e.preventDefault && e.deltaY && (
        (e.deltaY > 0 && scrollTop >= this.scrollContainer.scrollHeight - this.scrollContainer.offsetHeight) ||
        (e.deltaY < 0 && scrollTop <= 0)
      )
    ) {
      // e.preventDefault();
    }
    // e.returnValue = false; */
  }

  preventDefaultForScrollKeys = (e) => {
    if (keys[e.keyCode]) {
      this.preventDefault(e);
      return false;
    }
  }

  componentDidMount() {
    window.onwheel = this.preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
    window.ontouchmove = this.preventDefault; // mobile
    // document.onkeydown  = this.preventDefaultForScrollKeys;
  }

  componentWillUnmount() {
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    // document.onkeydown = null;
  }

  getScrollContainer = (ref) => {
    this.scrollContainer = ref;
  }

  render() {
    const { className, styleName, rightArrow, pure, children, maxHeight, header, footer, chessfilter, noArrow } = this.props;
    return (
      <div className={cn(styles.Menu, styles[styleName], className, { [styles.Wrapper]: !pure }, { [styles.MenuChessfilter]: chessfilter })}>
        { header }
        <div ref={this.getScrollContainer} className={cn({ [styles.scrollArea]: !!maxHeight }, 'custom-scrollbar')} style={{ maxHeight }}>
          {children}
        </div>
        {noArrow ? '' : (<div
          className={cn(styles.Arrow, {
            [styles.RightArrow]: rightArrow,
            [styles.RightArrowInCollection]: location.href.includes('ncollection')
          })}
        ></div>)}
        { footer }
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/common/Menu/Menu.js